import { render, staticRenderFns } from "./WxStoreUser.vue?vue&type=template&id=52f00861&scoped=true&"
import script from "./WxStoreUser.vue?vue&type=script&lang=js&"
export * from "./WxStoreUser.vue?vue&type=script&lang=js&"
import style0 from "./WxStoreUser.vue?vue&type=style&index=0&id=52f00861&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f00861",
  null
  
)

export default component.exports